module.exports = __webpack_public_path__ + "static/media/family_09.ad00fc62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_09.jpg
// module id = 5841
// module chunks = 0